module.exports = "<div class=\"container my-3\">\n  <filtered-list></filtered-list>\n</div>"